import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  public numberOfHistoricalQuartersPerCapita: number;
  public perCapitaHistoricalData: number[];
  constructor() {}

  public ifNullThenZero(value): number {
    const returnValue =
      isNaN(value) || value < 0 || value === '' || !isFinite(value)
        ? 0
        : Math.round(value);
    return returnValue;
  }

  public forPercentage(value): number {
    const returnValue =
      isNaN(value) || value < 0 || value === '' || !isFinite(value)
        ? 0
        : value.toFixed(7);
    return Number(returnValue);
  }

  public checkZeroOrEmptyString(value: any): boolean {
    const returnValue = value === 0 || value !== '';
    return returnValue;
  }

  public roundOff(value): number {
    const returnValue =
      isNaN(value) || value === '' || !isFinite(value)
        ? 0
        : Math.round(value);
    return returnValue;
  }

  public setCountHistoricalQuarter(QuarterInfoDates: any){
    let count=0;
    let data=[];
    for (var idx = 0; idx < QuarterInfoDates.length; idx++) {
      if (QuarterInfoDates[idx].Historical ==1 && QuarterInfoDates[idx].Partial==0 ) {
        count++;
        data.push(0);
      }
    }
    this.numberOfHistoricalQuartersPerCapita=count;
    this.perCapitaHistoricalData=data;
  }
  public getHistoricalCountPerCapita(){
    return this.numberOfHistoricalQuartersPerCapita;
  }
  public getHistoricalDataPerCapita(){
    return this.perCapitaHistoricalData;
  }
}
